import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Star, ShoppingBag, Clock, Shield } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>About Our Food Delivery Service</h1>
          <p>Connecting you with the best local restaurants for a delicious dining experience at home.</p>
          <Link to="/" className="btn btn-primary btn-hero">
            Browse Restaurants <ChevronRight size={16} />
          </Link>
        </div>
      </div>

      {/* Mission Section */}
      <div className="about-section container">
        <div className="section-header">
          <h2 className="section-title">Our Mission</h2>
          <div className="section-divider"></div>
        </div>
        <div className="mission-content">
          <div className="mission-text">
            <p>
              We created this platform to bridge the gap between amazing local restaurants and hungry customers. 
              Our mission is to make quality restaurant food accessible to everyone, while helping local 
              businesses thrive in the digital age.
            </p>
            <p>
              Unlike other delivery services, we focus exclusively on restaurants - no supermarkets or shops. 
              This allows us to optimize the entire experience for hot, fresh food delivery and provide 
              specialized support to our restaurant partners.
            </p>
          </div>
          {/* <div className="mission-image"></div> */}
        </div>
      </div>

      {/* How It Works Section */}
      <div className="about-section how-it-works-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">How It Works</h2>
            <div className="section-divider"></div>
          </div>
          <div className="step-cards">
            <div className="step-card">
              <div className="step-icon">
                <div className="icon-circle">1</div>
              </div>
              <h3>Choose Your Restaurant</h3>
              <p>Browse our curated selection of local restaurants and find your favorite.</p>
            </div>

            <div className="step-card">
              <div className="step-icon">
                <div className="icon-circle">2</div>
              </div>
              <h3>Select Your Food</h3>
              <p>Explore menus and customize your order exactly how you like it.</p>
            </div>

            <div className="step-card">
              <div className="step-icon">
                <div className="icon-circle">3</div>
              </div>
              <h3>Pay Securely</h3>
              <p>Use our simple checkout process with secure payment options.</p>
            </div>

            <div className="step-card">
              <div className="step-icon">
                <div className="icon-circle">4</div>
              </div>
              <h3>Get It Delivered</h3>
              <p>Track your order as it makes its way directly to your door.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="about-section container">
        <div className="section-header">
          <h2 className="section-title">Why Choose Us</h2>
          <div className="section-divider"></div>
        </div>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">
              <ShoppingBag size={32} />
            </div>
            <h3>Restaurant-Focused</h3>
            <p>We specialize exclusively in restaurant food delivery for the best experience.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <Star size={32} />
            </div>
            <h3>Quality Guaranteed</h3>
            <p>We partner only with restaurants committed to quality and customer satisfaction.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <Clock size={32} />
            </div>
            <h3>Fast Delivery</h3>
            <p>Our optimized delivery network ensures your food arrives hot and fresh.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <Shield size={32} />
            </div>
            <h3>Easy Ordering</h3>
            <p>Our intuitive platform makes finding and ordering your favorite food simple.</p>
          </div>
        </div>
      </div>

{/*  
      { Team Section }
      <div className="about-section team-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Meet Our Team</h2>
            <div className="section-divider"></div>
          </div>
          <div className="team-members">
            <div className="team-member">
              <div className="member-image member-image-1"></div>
              <div className="member-info">
                <h3>Sarah Johnson</h3>
                <p>Founder & CEO</p>
              </div>
            </div>
            
            <div className="team-member">
              <div className="member-image member-image-2"></div>
              <div className="member-info">
                <h3>David Chen</h3>
                <p>Head of Restaurant Relations</p>
              </div>
            </div>
            
            <div className="team-member">
              <div className="member-image member-image-3"></div>
              <div className="member-info">
                <h3>Maria Rodriguez</h3>
                <p>Lead Developer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      */}


      {/* CTA Section */}
      <div className="cta-section">
        <div className="container">
          <h2>Ready to Order?</h2>
          <p>Discover the best restaurants in your area and enjoy a delicious meal today!</p>
          <Link to="/" className="btn btn-primary btn-lg">Browse Restaurants</Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;